/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType } from "igniteui-react-core";
import { StringBuilder } from "igniteui-react-core";
import { stringIsNullOrEmpty } from "igniteui-react-core";
import { isNaN_ } from "igniteui-react-core";
/**
 * @hidden
 */
var DatePickerVisualModelExport = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(DatePickerVisualModelExport, _super);
    function DatePickerVisualModelExport() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.b = 0;
        _this.a = 0;
        _this.j = null;
        _this.k = null;
        _this.l = null;
        _this.f = 0;
        _this.h = null;
        _this.i = null;
        _this.e = null;
        _this.d = null;
        _this.c = null;
        return _this;
    }
    DatePickerVisualModelExport.prototype.g = function () {
        var a = new StringBuilder(0);
        a.l("{");
        a.l("density : " + this.b + ", ");
        a.l("baseTheme : " + this.a + ", ");
        if (!stringIsNullOrEmpty(this.j)) {
            a.l("textStyleFontStyle : \"" + this.j + "\", ");
        }
        if (!stringIsNullOrEmpty(this.k)) {
            a.l("textStyleFontVariant : \"" + this.k + "\", ");
        }
        if (!stringIsNullOrEmpty(this.l)) {
            a.l("textStyleFontWeight : \"" + this.l + "\", ");
        }
        if (!stringIsNullOrEmpty(this.h)) {
            a.l("textStyleFontFamily : \"" + this.h + "\", ");
        }
        if (!stringIsNullOrEmpty(this.i)) {
            a.l("textStyleFontStretch : \"" + this.i + "\", ");
        }
        if (!isNaN_(this.f)) {
            a.l("textStyleFontSize : " + this.f + ", ");
        }
        var b = "popupModel";
        a.l(b + ": " + this.e.f() + ", ");
        var c = "inputGroupModel";
        a.l(c + ": " + this.d.y() + ", ");
        var d = "calendarModel";
        if (this.e.d) {
            a.l(d + ": " + this.c.o() + ", ");
        }
        else {
            a.l(d + ":{}, ");
        }
        a.l("}");
        return a.toString();
    };
    DatePickerVisualModelExport.$t = markType(DatePickerVisualModelExport, 'DatePickerVisualModelExport');
    return DatePickerVisualModelExport;
}(Base));
export { DatePickerVisualModelExport };
//# sourceMappingURL=DatePickerVisualModelExport.js.map
